// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11 2H2V11H11V2Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2 13V22H11V13H2Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13 22H22V2H13V22Z"}}]};

const ComponentLayoutFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'component-layout-filled',
    ref,
    icon: element,
  },
));

ComponentLayoutFilledIcon.displayName = 'ComponentLayoutFilledIcon';

export default ComponentLayoutFilledIcon;
